import React from "react";
import { ShoppingCart, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./HeaderMenu.css";

export default function HeaderMenu({ stallName, cartCount }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/stalls-user");
  };

  const handleCartClick = () => {
    navigate("/cart-summary"); // ✅ navigate to cart summary page
  };

  return (
    <div className="header-menu">
      <div className="header-left" onClick={handleBack}>
        <ArrowLeft size={22} className="back-icon" />
      </div>

      <span className="stall-name-header">{stallName}</span>

      <div className="cart-icon" onClick={handleCartClick}>
        <ShoppingCart size={24} />
        {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
      </div>
    </div>
  );
}
